/**
 * ページ読み込み時、ハッシュ値があればスクロールする
 */
const anchorLink = (): void => {
  const hash: string = location.hash;
  const target: HTMLElement | null = document.getElementById(hash.replace('#', ''));
  const headerHeight: number = document.querySelector('.l-header')?.clientHeight || 0;
  if (target !== null) {
    window.addEventListener('load', () => {
      window.scrollTo({
        top: target.getBoundingClientRect().top + window.pageYOffset - headerHeight,
        behavior: 'smooth',
      });
    });
  }
};

export default anchorLink;
